import { http } from '../../config/axios'

export default function getPermissao(): Promise<any[]> {
  return http
    .get('api/permissao')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getPermissao', error)
      throw Error(error.response.data)
    })
}
